module.exports = __webpack_public_path__ + "static/media/avatar-05.a7a4fb1d.svg";